import { SELECT_DISCOUNT_PROGRAM } from "../action";

export function setDiscountProgram(discountProgram) {
  return (dispatch) => {
    dispatch({
      type: SELECT_DISCOUNT_PROGRAM,
      payload:  discountProgram ,
    });
  };
}
